var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7256_89031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12Z",
    fill: "#F1F1F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7256_89031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.90601 -0.000279427V14.7264H7.27599L12.0002 6.54445H24.0002V-0.000279427H1.90601ZM1.90601 -0.000279427V14.7264H7.27599L12.0002 6.54445H24.0002V-0.000279427H1.90601Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9995H11.422L16.7242 18.6973V14.7278L7.27571 14.7263L0 2.24776V23.9995ZM0 23.9995H11.422L16.7242 18.6973V14.7278L7.27571 14.7263L0 2.24776V23.9995Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 6.54442L16.724 14.7263L11.4233 23.9998H23.9997V6.54442H11.9997ZM11.9997 6.54442L16.724 14.7263L11.4233 23.9998H23.9997V6.54442H11.9997Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 6.54445C15.0125 6.54445 17.4548 8.987 17.4548 11.9997C17.4548 15.0126 15.0125 17.4551 11.9996 17.4551C8.98673 17.4551 6.54443 15.0126 6.54443 11.9997C6.54443 8.987 8.98673 6.54445 11.9996 6.54445Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 7.63535C14.4099 7.63535 16.3638 9.58924 16.3638 11.9995C16.3638 14.4098 14.4099 16.3637 11.9997 16.3637C9.58939 16.3637 7.6355 14.4098 7.6355 11.9995C7.6355 9.58924 9.58939 7.63535 11.9997 7.63535Z",
    fill: "#4285F4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIcon);
export default __webpack_public_path__ + "static/media/chrome-icon.ac82f41d4834f6802a27916d97d74181.svg";
export { ForwardRef as ReactComponent };